// Goal dates (#155). "Track from" is meant to be in the past (when selling
// started), but a deadline or checkpoint that has already gone by makes no
// sense to SET. Dates the goal already had are left alone, so editing an older
// goal (whose early checkpoints are now history) still saves.

// YYYY-MM-DD in the viewer's own calendar — what an <input type="date"> holds.
export const localISODate = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

// The dates a saved goal already holds — exempt from the "not in the past" rule.
export const savedGoalDates = (goal) => new Set([goal?.byDate, ...((goal?.milestones || []).map((m) => m.byDate))]
  .filter(Boolean).map((d) => String(d).slice(0, 10)));

// '' when the dates are fine; otherwise one sentence saying what to fix.
export function goalDatesProblem({ startDate, byDate, milestones = [], today, saved = new Set() }) {
  const isNewPast = (d) => !!d && d < today && !saved.has(d);
  if (startDate && byDate && startDate > byDate) return '“Track from” has to be on or before the deadline.';
  if (isNewPast(byDate)) return 'The deadline is in the past — pick today or a later date.';
  for (const m of milestones) {
    if (!m || !m.byDate) continue;
    if (isNewPast(m.byDate)) return `The checkpoint on ${m.byDate} is in the past — pick today or a later date.`;
    if (byDate && m.byDate > byDate) return `The checkpoint on ${m.byDate} is after the deadline.`;
    if (startDate && m.byDate < startDate) return `The checkpoint on ${m.byDate} is before “Track from”.`;
  }
  return '';
}

// The earliest date a picker offers: today (or a later floor such as "Track
// from"). A past date the goal already holds gets no floor, so the browser
// doesn't flag it as invalid.
export function pickerMin(value, { today, saved = new Set() }, ...floors) {
  if (value && saved.has(value) && value < today) return undefined;
  return [today, ...floors].filter(Boolean).sort().pop();
}
